// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { NetworkStatuses } from '../../../../types/network';
import { askInitialState as askInitialStateAction } from '../../actions/init';
import GridsRouteWatcher from '../../components/routes/GridsRouteWatcher';
import { getActivePoolsIds } from '../../selectors/ui';

const legacySelector = memoize((state) => ({
  shouldInit: getActivePoolsIds(state) === null && state.network === NetworkStatuses.CONNECTED,
}));

type GridsRouteWatcherContainerProps = {
  className?: string;
};

const GridsRouteWatcherContainer = (ownProps: GridsRouteWatcherContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(legacySelector);

  const init = useCallback(() => {
    dispatch(askInitialStateAction());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      init,
    }),
    [init],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsRouteWatcher {...enhancedProps} />;
};

export default GridsRouteWatcherContainer;
